<template>
  <div class="template-container">
    <site-header v-bind:statusAction="statusAction" />
    <site-header-bottom />

    <router-view @status-action="onStatusAction" />
    <site-footer />
  </div>
</template>



<script type="text/babel">
import SiteHeader from "./partials/TheSiteHeader.vue";
import SiteFooter from "./partials/TheSiteFooter.vue";
import SiteHeaderBottom from "./partials/TheSiteHeaderBottom.vue";


export default {
  components: {
    SiteHeader,
    SiteHeaderBottom,
    SiteFooter
  },
  data() {
    return {
      statusAction: {}
    };
  },
  mounted() {
    this.$utils.setLayout("horizontal");
  },

  beforeCreate() {},

  methods: {
    onStatusAction(e) {
    
      this.statusAction = e;
  
    }
  }
};
</script>
